// Cell.js
import React, { useEffect, useState } from "react";
import "./cell.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showZetLessonDetailAction, zetLessonDetailDataAction } from "../../redux/actions/actions";
import ModalChangeDiscip from "../modalChangeDiscip/ModalChangeDiscip";
import { StudentService } from "../studentService";
import { Icon } from "../../../personal-studio-components/frame";

const rgbToRgba = (rgb, alpha = 1) => {
  if (rgb) return rgb.replace("rgb", "rgba").replace(")", `, ${alpha})`);
};
const Cell = ({
  cellData,
  rowIndex,
  colIndex,
  twoDimensionalArray,
  width,
  height,
  color,
  currCellBorder,
  getLinegraph,
  highlighted,
  is_elective,
  percent_complete,
  percent_paid,
  zetWidth,
}) => {
  const { discip_short_name, zet_name, semester_id, ind_mod_discip_id, sub_name, elective, has_access, show_content, renderPercentPaid } =
    cellData;
  const [isBorderLight, setIsBorderLight] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const dispatch = useDispatch();
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [hasLessons, setHasLessons] = useState(false);
  const navigate = useNavigate();

  const getLessons = async () => {
    // if (is_paid === 0) return;
    const request = {
      method: "post",
      path: "/student/linegraph/discip/lessons",
      data: {
        access_token,
        study_contract_id: contractId,
        semester_id,
        ind_mod_discip_id,
      },
    };
    dispatch(showZetLessonDetailAction(true));
    await StudentService.send(request, (response) => {
      if (response) {
        dispatch(
          zetLessonDetailDataAction({
            lessons: response,
            discip_short_name,
            zet_name,
          }),
        );
      }
    });
  };
  const getLessonState = async () => {
    const request = {
      method: "post",
      path: "/student/linegraph/discip/state",
      data: {
        access_token,
        study_contract_id: contractId,
        semester_id,
        ind_mod_discip_id,
      },
    };
    await StudentService.send(request, (response) => {
      if (response) {
        setHasLessons(response.has_lessons);
      }
    });
  };
  const getCellStyle = (rowIndex, colIndex) => {
    const currentCell = twoDimensionalArray[rowIndex][colIndex];
    const nextCell = colIndex + 1 < width ? twoDimensionalArray[rowIndex][colIndex + 1] : null;
    const prevCell = colIndex - 1 >= 0 ? twoDimensionalArray[rowIndex][colIndex - 1] : null;
    const topCell = rowIndex - 1 >= 0 ? twoDimensionalArray[rowIndex - 1][colIndex] : null;
    const bottomCell = rowIndex + 1 < height ? twoDimensionalArray[rowIndex + 1][colIndex] : null;

    const isBorderRight = !(nextCell && nextCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id);
    const isBorderLeft = !(prevCell && prevCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id);
    const isBorderTop = !(topCell && topCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id);
    const isBorderBottom = !(bottomCell && bottomCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id);
    let classNames = [];
    if (isBorderTop) classNames.push("bt");
    if (isBorderRight) classNames.push("br");
    if (isBorderLeft) classNames.push("bl");
    if (isBorderBottom) classNames.push("bb");

    return classNames.join(" ");
  };

  const getCellBorderClass = (rowIndex, colIndex) => {
    const currentCell = twoDimensionalArray[rowIndex][colIndex];
    const nextCell = colIndex + 1 < width ? twoDimensionalArray[rowIndex][colIndex + 1] : null;
    const prevCell = colIndex - 1 >= 0 ? twoDimensionalArray[rowIndex][colIndex - 1] : null;
    const topCell = rowIndex - 1 >= 0 ? twoDimensionalArray[rowIndex - 1][colIndex] : null;
    const bottomCell = rowIndex + 1 < height ? twoDimensionalArray[rowIndex + 1][colIndex] : null;

    const isBorderRight = !(
      nextCell &&
      nextCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id &&
      nextCell.semester_id === currentCell?.semester_id
    );
    const isBorderLeft = !(
      prevCell &&
      prevCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id &&
      prevCell.semester_id === currentCell?.semester_id
    );
    const isBorderTop = !(
      topCell &&
      topCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id &&
      topCell.semester_id === currentCell?.semester_id
    );
    const isBorderBottom = !(
      bottomCell &&
      bottomCell.ind_mod_discip_id === currentCell?.ind_mod_discip_id &&
      bottomCell.semester_id === currentCell?.semester_id
    );

    const classNames = [];
    if (isBorderTop) classNames.push("highlight-border-top");
    if (isBorderRight) classNames.push("highlight-border-right");
    if (isBorderLeft) classNames.push("highlight-border-left");
    if (isBorderBottom) classNames.push("highlight-border-bottom");

    return classNames.join(" ");
  };
  const handleShowModal = (e) => {
    e.stopPropagation();
    setIsShowModal(true);
  };

  const rgbaColor = rgbToRgba(color, 0.1);

  const cellBorderClass = highlighted ? getCellBorderClass(rowIndex, colIndex) : "";

  useEffect(() => {
    if (currCellBorder.zet_name === zet_name && currCellBorder.ind_mod_discip_id === ind_mod_discip_id) {
      setIsBorderLight(true);
    }
    return () => setIsBorderLight(false);
  }, [currCellBorder.ind_mod_discip_id, currCellBorder.zet_name]);
  useEffect(() => {
    getLessonState();
  }, []);
  return (
    <div className={`rootZet`} title={discip_short_name} onClick={getLessons}>
      <div
        key={`merged-cell-${rowIndex}-${colIndex}`}
        className={`cellMerged ${cellBorderClass} ${
          isBorderLight ? "blight" : ""
        } ${has_access === false ? "hasAccess" : ""} ${getCellStyle(rowIndex, colIndex)}`}
        style={{ backgroundColor: rgbaColor, borderColor: color }}
      >
        <div className="container">
          {/* {isDiscipNameRender && show_content !== false ? (
            <div className="discipName">
              {discip_short_name}
              <br />
            </div>
          ) : null} */}
          {isShowModal && (
            <ModalChangeDiscip
              getLinegraph={getLinegraph}
              setIsShowModal={setIsShowModal}
              isShowModal={isShowModal}
              elective={elective}
              access_token={access_token}
              contractId={contractId}
            />
          )}
        </div>
        <div className="zetName-container">
          {show_content !== false && (
            <div className="zetName" title={sub_name}>
              <div className="subName">{sub_name && sub_name}</div>
            </div>

            //  <div className="zetIsCompleted">
            //   {is_completed && <Icon name="check" title="Завершено" />}
            // </div>

            //   <div
            //   className="zetIsPayd"
            //   title="Оплатить"
            //   onClick={() => navigate("/payment")}
            // >
            //   {is_paid === 0 && (
            //     <div className="section_icon">
            //       <Icon name="ruble" className="iconRuble" />
            //     </div>
            //   )}
            // </div>
          )}
          {renderPercentPaid && (
            <>
              {percent_complete < 100 ? (
                <div
                  title={"Освоено: " + percent_complete + "%"}
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "10px",
                    background: "#ddd",
                    padding: 0,
                    borderRadius: "7px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      width: `${percent_complete}%`,
                      height: "10px",
                      margin: 0,
                      background: color,
                    }}
                  ></div>
                </div>
              ) : // <progress
              //   style={{
              //     "--progress-bg": "#ddd",
              //     "--progress-fill": color,
              //     maxWidth: zetWidth,
              //   }}
              //   title={"Освоено: " + percent_complete + "%"}
              //   max={100}
              //   value={percent_complete}
              // ></progress>

              hasLessons && percent_complete == 100 ? (
                <div className="zetIsCompleted" title="Завершено">
                  <Icon name="check" />
                </div>
              ) : (
                !hasLessons &&
                percent_complete == 100 && (
                  <div
                    title={"Откроется позже"}
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "10px",
                      background: "#ddd",
                      padding: 0,
                      borderRadius: "7px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        width: `0%`,
                        height: "10px",
                        margin: 0,
                        background: color,
                      }}
                    ></div>
                  </div>
                )
              )}
              {percent_paid < 100 && (
                <div className={`zetIsPayd`} title={"Оплачено: " + percent_paid + "%"} onClick={() => navigate("/payment")}>
                  <div className="section_icon">
                    <Icon name="ruble" className="iconRuble" />
                  </div>
                </div>
              )}
              <div className="isElective">
                {is_elective && (
                  <div className="section_icon" onClick={handleShowModal} title="Сменить дисциплину">
                    <Icon name="double_arrows" className="icon" />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Cell;
